import { netsparkAxios } from 'core/services/HTTPService';
import { IEngagementsOrdersByPeriodItem } from 'pages/Dashboard/Dashboard.models';
import {
  getEngagementsOrdersByPeriodsUrl,
} from 'pages/Dashboard/api/apiUrls';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';

const getEngagementsOrdersByPeriod = (
  signal: AbortSignal, params: TPeriod,
) => netsparkAxios
  .get<IEngagementsOrdersByPeriodItem[]>(getEngagementsOrdersByPeriodsUrl, { signal, params });

export default getEngagementsOrdersByPeriod;
